// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1TFSq","addWidgetButton":"Header_addWidgetButton__1Pe64","dashboardTabs":"Header_dashboardTabs__gLIih","active":"Header_active__2imBZ"};